import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDIcon, FDPaper, FDStack,
} from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { navigateByRelationship } from 'Views/Page/Content/Templates';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const useStyles = buildUseStyles('VerifyIdentity', (() => ({
  hyperlink: {
    paddingLeft: '5px',
    textDecoration: 'underline',
    color: 'inherit',
  },
})));

const VerifyIdentity = ({ relationship }) => {
  const classes = useStyles();
  const { setModalCollection, clearModalCollection } = useModalContext();
  const { loadPageContentLink } = usePageContentContext();

  const handleOnClick = (e) => {
    e.preventDefault();
    navigateByRelationship(relationship, setModalCollection, loadPageContentLink, clearModalCollection);
  };

  return (
    <FDPaper color={'info'} appearance={'flat'} padding={2}>
      <FDStack direction={'row'} spacing={0.5}>
        {relationship.meta('icon') ? <FDIcon icon={relationship.meta('icon')} /> : null}
        <FDBodyText value={
          <>
            <span>{relationship.meta('title')}</span>
            <a href="#" className={classes.hyperlink} onClick={handleOnClick}>{relationship.meta('prompt')} </a>
          </>
        }
        />
      </FDStack>
    </FDPaper>
  );
};

VerifyIdentity.defaultProps = {
};

VerifyIdentity.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default VerifyIdentity;
